import styled from "styled-components";
import { detailsBackground } from "../../config/colors";

export const CharacteristicsWrapper = styled.table`
    background-color: ${detailsBackground};
    padding-left: 15px;
    padding-top: 15px;
    padding-right: 30px;
    padding-bottom: 5px;
    margin-top: 5px;
    margin-bottom: 20px;
    min-height: 150px;
    border-radius: 3px;

    @media print {
      height: 340px;
      background-color: inherit;
    }
`;

export const CharacteristicsItemWrapper = styled.tr`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 0.6px solid grey;
    margin: 2px 0px;
`;

export const CharacteristicsKey = styled.td`
  font-size: 0.875rem;
  line-height: 150%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  -webkit-box-orient: vertical;
  flex: 1;
  padding-right: 15px;
`;

export const CharacteristicsValue = styled(CharacteristicsKey)`
  align-self: flex-end;
  text-align:right;
`;

export const CharacteristicsUnit = styled(CharacteristicsKey)`
  font-size: 0.8rem;
  align-self: flex-end;
`;
